import React from "react";
import IndexNav from "../../IndexNav";
import {
  Bullet,
  BulletList,
  Container,
  Intro,
  Page,
  Section,
  SectionTitle,
  Text,
  Title,
  UpdatedText,
} from "./Styled";

const Privacy = () => {
  return (
    <>
      <IndexNav />
      <Page>
        <Container>
          <Title>PepHub Boards Privacy Policy</Title>
          <UpdatedText>Last updated: April 11, 2026</UpdatedText>

          <Intro>
            This Privacy Policy explains how PepHub Boards collects, uses, and protects information
            when you use our application and related services.
          </Intro>

          <Section>
            <SectionTitle>1. Information We Collect</SectionTitle>
            <BulletList>
              <Bullet>Account details such as name, organization, email, and encrypted credentials.</Bullet>
              <Bullet>Workspace data such as boards, lists, cards, comments, and activity logs.</Bullet>
              <Bullet>Operational data such as login/session and basic usage diagnostics.</Bullet>
            </BulletList>
          </Section>

          <Section>
            <SectionTitle>2. How We Use Information</SectionTitle>
            <Text>We use collected data to:</Text>
            <BulletList>
              <Bullet>Provide and improve PepHub Boards functionality.</Bullet>
              <Bullet>Authenticate users and maintain account security.</Bullet>
              <Bullet>Respond to support, feedback, and feature requests.</Bullet>
              <Bullet>Maintain service reliability and prevent abuse.</Bullet>
            </BulletList>
          </Section>

          <Section>
            <SectionTitle>3. Sharing of Information</SectionTitle>
            <Text>
              We do not sell personal information. Data may be shared only when required to operate the
              service, comply with legal obligations, or protect the rights and safety of users.
            </Text>
          </Section>

          <Section>
            <SectionTitle>4. Data Retention</SectionTitle>
            <Text>
              We retain account and workspace data while your account is active and as needed for legal,
              security, and operational purposes.
            </Text>
          </Section>

          <Section>
            <SectionTitle>5. Security</SectionTitle>
            <Text>
              We implement reasonable technical and organizational safeguards to protect your data.
              However, no system can guarantee absolute security.
            </Text>
          </Section>

          <Section>
            <SectionTitle>6. Your Choices</SectionTitle>
            <Text>You can request account updates or deletion through support channels.</Text>
          </Section>

          <Section>
            <SectionTitle>7. Policy Updates</SectionTitle>
            <Text>
              We may update this policy from time to time. The latest version will be posted here with
              the updated date.
            </Text>
          </Section>

          <Section>
            <SectionTitle>8. Contact</SectionTitle>
            <Text>
              For privacy questions or requests, contact the PepHub Boards team through the in-app
              feedback page.
            </Text>
          </Section>
        </Container>
      </Page>
    </>
  );
};

export default Privacy;
